import { LoginComponent } from "vebto-client/auth/login/login.component";
import { GuestGuard } from "vebto-client/guards/guest-guard.service";
import { CustomPageComponent } from "vebto-client/core/ui/custom-page/custom-page.component";
var ɵ0 = { permissions: ['pages.view'] };
var routes = [
    { path: '', component: LoginComponent, canActivate: [GuestGuard] },
    { path: 'builder', loadChildren: 'app/html-builder/html-builder.module#HtmlBuilderModule' },
    { path: 'admin', loadChildren: 'app/admin/app-admin.module#AppAdminModule' },
    { path: 'billing', loadChildren: 'vebto-client/billing/billing.module#BillingModule' },
    {
        path: 'pages/:id/:slug',
        component: CustomPageComponent,
        data: ɵ0
    },
];
var AppRoutingModule = /** @class */ (function () {
    function AppRoutingModule() {
    }
    return AppRoutingModule;
}());
export { AppRoutingModule };
export { ɵ0 };



// WEBPACK FOOTER //
// /mnt/e/apps/architect3/client/src/app/app-routing.module.ts.pre-build-optimizer.js